
import { addDoc, collection, doc, documentId, getDoc, getDocs, getFirestore, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { SHOP } from '../entities/Shop';
import { TICKET, ticketConverter, TicketStatus } from '../entities/Ticket';
import firebase from '../firebase/Firebase';
import { sliceByNumber } from '../lib/array';

export const PER_PAGE = 12;
const store = getFirestore(firebase);

export const getTicket = async (shopId: string, ticketId: string) => {
  const shopRef = doc(store, SHOP, shopId)
  const ticketRef = doc(shopRef, TICKET, ticketId).withConverter(ticketConverter);
  return await getDoc(ticketRef).then((doc) => {
    return doc.data();
  }).catch((error) => {
    console.warn(error);
    return null
  });
};

export const getTicketsByEmail = async (shopId: string, email: string) => {
  if (!shopId || !email) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef,
    where('emailFrom','==', email)
  )
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  })
}

export const getTicketsByIds = async (shopId: string, ids: string[]) => {
  if (!shopId || !ids || !ids.length) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const sliced = sliceByNumber(ids, 10)
  const promises = sliced.map((ids) => {
    const q = query(ticketRef, 
      where(documentId(),'in', ids)
    )
    return getDocs(q).then((snap) => snap.docs.map((doc) => doc.data()))
  })
  return await Promise.all(promises).then((results) => results.flat())
}

// 未解決お問い合せ
export const getNotClosedTickets = async (shopId: string) => {
  if (!shopId) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef, 
    where('ticketStatus','!=', TicketStatus.closed)
  )
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  })
}

export const getNotClosedTicketsSnapshot = async (shopId: string) => {
  if (!shopId) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef, 
    where('ticketStatus','!=', TicketStatus.closed)
  )
  const close = onSnapshot(q, (snapshot) => {
    snapshot.docs.map((doc) => doc.data())
  })
}

export const getClosedTicketsStartedBetween = async (shopId, start, end) => {
  if (!shopId || !start || !end) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef, 
    where('ticketStatus','==', TicketStatus.closed),
    where('startedAt', '>=', start),
    where('startedAt', '<=', end)
  )
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  })
}

export const getClosedTicketsClosedBetween = async (shopId, start, end) => {
  if (!shopId || !start || !end) return

  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef, 
    where('ticketStatus','==', TicketStatus.closed),
    where('closedAt', '>=', start),
    where('closedAt', '<=', end)
  )
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  })
}

// 担当者なし
export const getUnAssignedTickets = async (shopId: string) => {
  const ref = doc(store, SHOP, shopId)
  const ticketRef = collection(ref, TICKET).withConverter(ticketConverter)
  const q = query(ticketRef,
    where('agentId', '==', null),
  )
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  })
}

export const setTicket = async (shopId: string, ticket) => {
  const shopRef = doc(store, SHOP, shopId)
  const ticketRef = doc(shopRef, TICKET, ticket.id).withConverter(ticketConverter);
  return await setDoc(ticketRef, ticket).catch((error) => {
    console.warn(error);
    return null
  });
};


export const updateTicket = async (shopId: string, ticket) => {
  const shopRef = doc(store, SHOP, shopId)
  const ticketRef = doc(shopRef, TICKET, ticket.id).withConverter(ticketConverter);
  return await updateDoc(ticketRef, ticket).catch((error) => {
    console.warn(error);
    return null
  });
};

export const addTicket = async (shopId: string, ticket) => {
  const shopRef = doc(store, SHOP, shopId)
  const ticketRef = collection(shopRef, TICKET).withConverter(ticketConverter);
  return await addDoc(ticketRef, ticket).then((ref) => ref.id).catch((error) => {
    console.warn(error);
    return null
  });
};




